import React from 'react';
import { KeycloakProfile } from 'keycloak-js';
import { AuthContext } from './AuthContext';
import { Session } from '../../peer-colab-model/Session';

// ...existing code...

const fakeProfile: KeycloakProfile = {
  id: 'dev-user',
  username: 'devuser',
  email: 'dev@localhost',
  firstName: 'Dev',
  lastName: 'User',
  enabled: true,
  emailVerified: true,
};

// ...existing code...

export const MockAuthProvider = ({ children }: { children: React.ReactNode }) => {
  Session.useDevDependencies();

  const login = () => alert('Mock login: already authenticated');
  const logout = () => alert('Mock logout: nothing to do');

  return (
    <AuthContext.Provider value={{
      keycloak: null,
      initialized: true,
      authenticated: true,
      profile: fakeProfile,
      login,
      logout,
    }}>
      {children}
    </AuthContext.Provider>
  );
};
